import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_63: DocMigration = {
  maxSchemaVersion: "0.0.63",
  description: "Refactor Palette to implement DocEntityBase",
  apply(json: any) {
    if (json.palettes) {
      migrateModelToExtendDocEntityBase(json, "palettes");
    }
    return json;
  },
};

export default migration_0_0_63;
